import './registered-block.scss';

export default () => {
};
